import "bootstrap/dist/css/bootstrap.css";

import * as React from "react";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConfigProvider } from "antd";
import locale from "antd/locale/en_GB";
import { ConnectedRouter } from "connected-react-router";
import dayjs from "dayjs";
import { createBrowserHistory } from "history";
import i18next from "i18next";
import * as ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";
import { toast } from "react-toastify";
import { ThemeProvider } from "styled-components";

import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import GlobalStyle, { theme } from "./GlobalStyle";
import registerServiceWorker from "./registerServiceWorker";
import configureStore from "./store/configureStore";
import "./i18n";
import "dayjs/locale/en-gb";
// Create browser history to use in the Redux store
const baseUrl = document
  .getElementsByTagName("base")[0]
  .getAttribute("href") as string;
const history = createBrowserHistory({ basename: baseUrl });
dayjs.locale("en-GB");
// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

toast.configure({ autoClose: 14000 });

const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      onError: (error) => {
        toast.error(
          //@ts-ignore
          error?.stack?.Message
            ? //@ts-ignore
              error?.stack?.Message
            : "Something went wrong!",
        );
      },
    },
    queries: {
      onError: () => {
        toast.error("Something went wrong");
      },
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <I18nextProvider i18n={i18next}>
          <ThemeProvider {...{ theme }}>
            <ErrorBoundary>
              {/*antd config*/}
              <ConfigProvider locale={locale}>
                <App />
              </ConfigProvider>
            </ErrorBoundary>
            <GlobalStyle />
          </ThemeProvider>
        </I18nextProvider>
      </ConnectedRouter>
    </Provider>
  </QueryClientProvider>,
);

registerServiceWorker();
